import {Container, Grid, Modal, Typography} from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { makeStyles } from '@mui/styles';
import React, {useEffect, useState} from "react";
import NativePlayer from "../NativePlayer/NativePlayer";
import Products from "../ProductsModal/Products";
import PhotoView from "../PhotoView/PhotoView";
import "./ModalView.css";
import ShareIcon from '@mui/icons-material/Share';
import {Box, IconButton, useMediaQuery} from "@mui/material";
import ShareMobile from "../Share/ShareMobile";
import ShareDesktop from "../Share/ShareDesktop";
import {Swiper, SwiperSlide} from "swiper/react";
import { Virtual } from "swiper/modules";
import 'swiper/css';
import Truncate from "react-truncate";
import SimpleBar from "simplebar-react";
import {useTheme} from "@mui/material/styles";

const useStyles = makeStyles((theme) => {

    return {
            modalViewContent: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                backgroundColor: '#ffffff',
                '&:focus-visible': {
                    outline: 'none'
                },
                '& > div:focus-visible': {
                    outline: 'none'
                }
            },
            modalViewContentWrapper: {
                aspectRatio: '9/16',
                position: 'relative',
                margin: 0,
                overflow: 'hidden',
                width: '100%',
                '@supports not(aspect-ratio)': {
                    '& .modal_view_content_wrapper_video': {
                        paddingTop: '177.77%',
                    }
                },
                '& $widgetContentLandScape': {}
            },
            modalViewAction: {
                position: 'absolute',
                display: 'flex',
                cursor: 'pointer',
                top: 'calc(50% - 23px)',
                alignItems: 'center',
                justifyContent: 'center',
                left: `-55px`,
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(0,0,0,0.5)',
                borderRadius: '50%',
                '& div': {
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center'
                },

                '&$right': {
                    right: '-55px',
                    left: 'auto',
                    zIndex: 10
                }
            },
            modalArrowHover: {
                "& $fade": {
                    animation: '$fadeInArrowIconCard 1s'
                }
            },
            widgetContentLandScape: {
                backgroundColor: '#000',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
            },
            right: {},
            fade: {},
            modalViewContentActionsClose: {
                position: 'absolute',
                right: '10px',
                top: '10px',
                zIndex: '1500',
                cursor: 'pointer',
                '& svg': {
                    fill: '#fff'
                }
            },
            modalViewProducts: {
                width: '100%',
                display: 'block',
            },
            // [configurationHelper.TABLET()]: {
            //     modalViewContentWrapper: {
            //         aspectRatio: '9/16',
            //         position: 'relative',
            //         margin: 0,
            //         overflow: 'hidden',
            //         '@supports not(aspect-ratio)': {
            //             paddingTop: '177.77%'
            //         }
            //     }
            // },
            [theme.breakpoints.down('sm')]: {
                modalViewProducts: {
                    position: 'absolute',
                    width: '100%',
                    bottom: '25px'
                },
                modalViewAction: {
                    display: 'none',
                },
                modalViewContentWrapper: {
                    width: "100%",
                    height: '100%'
                }
            },
        }
});

const getPhotoSource = (content) => (content.asset && content.asset.sources && content.asset.sources.length > 0 ? content.asset.sources[0]?.url : "")

const generateSessionId = () => {
    const generateRandomNum = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    let timeStamp = 0;
    if (typeof Date.now == 'function') {
        timeStamp = Date.now();
    } else {
        timeStamp = +new Date();
    }

    return timeStamp + generateRandomNum() + generateRandomNum() + '-' + generateRandomNum() + '-' + generateRandomNum() + '-' + generateRandomNum() + '-' + generateRandomNum() + generateRandomNum() + generateRandomNum();
}

const sourceAspectRatio = (content) => {
    if (!content) {
        return 9 / 16;
    }
    const {asset} = content;
    if (content.entityType === 1) {
        const {width, height} = asset.sources[0];
        return height / width;
    } else {
        const sourceImage = asset.sources && asset.sources.length > 0 ? asset.sources[0] : {height: 16, width: 9}
        return sourceImage.height / sourceImage.width;
    }
}

const calculateAspectRatio = (content) => {
    const aspectRatio = sourceAspectRatio(content);
    if (aspectRatio <= 0.5626)
        return "16/9";
    else if (aspectRatio > 0.5626 && aspectRatio < 0.76)
        return "4/3";
    else if (aspectRatio >= 0.76 && aspectRatio <= 1)
        return "1/1";
    else if (aspectRatio > 1)
        return "9/16";
    else
        return "16/9";

}


const style = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
};

const ModalView = ({getPrev, getNext, videos, activePosition, autoplay, modal, closeModal}) => {
    const isMobileView = useMediaQuery('(max-width:600px)');

    const [sessionId, setSessionId] = useState(generateSessionId());

    const [openShare, setOpenShare] = useState(false);

    const [swiperInstance, setSwiperInstance] = useState(null);
    const [whenIsOpen, setWhenIsOpen] = useState(false);

    const [isHoveringPrev, setIsHoveringPrev] = useState(false);
    const [isHoveringNext, setIsHoveringNext] = useState(false);

    const theme = useTheme();

    const classes = useStyles();
    const handleCloseModal = () => {
        setSessionId("");
        setWhenIsOpen(false);
        closeModal();
    }

    useEffect(() => {
        if (
            modal?.open &&
            modal?.position >= 0 &&
            swiperInstance &&
            !whenIsOpen
        ) {
            swiperInstance.slideTo(modal.position, 0);
            setWhenIsOpen(true);
        } else if (!modal?.open) {
            setWhenIsOpen(false);
        }
    }, [modal, swiperInstance, whenIsOpen]);

    const productsEnabledValue = true;

    const modalArrowEnabledValue = true;

    const itemsQty = videos?.length || 0;
    const handleShare = () => {
        setOpenShare(true);
    }
    const handleClose = () => {
        setOpenShare(false);
    }
    const {content} = modal;
    return <div>



            <Modal
                open={modal.open}
                keepMounted
                sx={{zIndex: 999999}}
                onClose={handleCloseModal}
            >
                <Box maxWidth={(productsEnabledValue ? theme.breakpoints.values.md : theme.breakpoints.values.sm)} width={'100%'} position={{xs: 'relative', sm: 'absolute'}} sx={style} >
                    <Container  maxWidth={(productsEnabledValue ? 'md' : 'sm')} disableGutters>
                        <Swiper
                            observer={true}
                            centerInsufficientSlides={true}
                            onInit={(swiper) => {
                                setSwiperInstance(swiper);
                                if (modal?.open && modal?.position >= 0) {
                                  swiper.slideTo(modal.position, 0);
                                  setWhenIsOpen(true);
                                }
                              }}
                            onSlideNextTransitionEnd={()=>{
                                if (whenIsOpen) {
                                    setTimeout(() => getNext(), 100);
                                  }
                            }}
                            onSlidePrevTransitionEnd={()=>{
                                if (whenIsOpen) {
                                    setTimeout(() => getPrev(), 100);
                                }
                            }}
                            // autoHeight={true}
                            virtual={{
                                enabled: true,
                                addSlidesAfter: 1,
                                addSlidesBefore: 1
                            }}
                            modules={[Virtual]}
                            slidesPerView={1}>
                            {
                                videos.map((item, index) => {
                                    const isVideo = item.entityType === 1 || false;
                                    const isPhoto = item.entityType === 7 || false;
                                    const aspectRatio = calculateAspectRatio(item);
                                    const isLandscape = aspectRatio !== "9/16";
                                    const isActive = index === activePosition && modal?.open;
                                    return <SwiperSlide key={item.id}>
                                        <Box display={'flex'} height={"100%"} alignItems={'center'}>
                                            <Grid container spacing={0}>

                                                <Grid item xs={12} sm={productsEnabledValue ? 6 : 12} >
                                                    <Box position={'relative'} sx={{backgroundColor: '#000000'}}>
                                                        <Box id={"content-holder"}

                                                             className={classes.modalViewContentWrapper + (isLandscape ? " " + classes.widgetContentLandScape : "")}>
                                                            <Box
                                                                height={"100%"}
                                                                className={'modal_view_content_wrapper_video ' + (isVideo ? "on" : "")}
                                                                style={isLandscape ? {height: '100%'} : {}}>
                                                                {(isVideo) && <NativePlayer isLandscape={isLandscape}
                                                                                          handleCloseModal={handleCloseModal}
                                                                                          index={index}
                                                                                          activePosition={activePosition}
                                                                                          video={item} autoplay={autoplay}
                                                                                          active={isActive}
                                                                                          sessionId={sessionId}/>}
                                                            </Box>
                                                            {isPhoto &&
                                                                <PhotoView handleCloseModal={handleCloseModal}
                                                                           src={getPhotoSource(item)}
                                                                           photo={item}/>}
                                                        </Box>
                                                        <Box px={2} width={'100%'} position={'absolute'}
                                                             display={{sm: 'flex', xs: 'flex'}}
                                                             top={{xs: 'calc(100% - 190px)', sm: '90%'}}
                                                             justifyContent={'flex-end'}>
                                                            <IconButton sx={{width: 'auto', cursor: 'pointer', '&:hover':{backgroundColor: 'inherit'}}} disableRipple onClick={handleShare}>
                                                                <ShareIcon htmlColor={"#ffffff"} sx={{fill: '#ffffff'}}/>
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                    <Box bgcolor={'#ffffff'} p={2} display={{xs: 'none', sm: 'block'}}>
                                                        <Box>
                                                            <Typography fontWeight={700}>
                                                                <Truncate lines={1}>
                                                                    {item.title}
                                                                </Truncate>
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <SimpleBar style={{maxHeight: "53px", overflowX: "hidden"}}>
                                                                <Typography fontSize={'14px'}>
                                                                {item.description}
                                                                </Typography>
                                                            </SimpleBar>

                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            {
                                                (productsEnabledValue && isActive && item) && <Grid sx={{backgroundColor: "#fff"}} item xs={12} sm={productsEnabledValue ? 6 : 12}>
                                                <Box height={{xs: 'auto', sm:'100%'}} maxWidth={'100%'} width={'100%'} className={classes.modalViewProducts}>
                                                    <Products clientId={TVSite.loginId} entityId={item.id} userId={item.user_id} 
                                                        matchedProducts={
                                                            item.products
                                                        }
                                                    />
                                                </Box>
                                                </Grid>
                                            }
                                            </Grid>
                                        </Box>
                                    </SwiperSlide>
                                })
                            }
                        </Swiper>
                    </Container>
                    {(modalArrowEnabledValue && itemsQty > 1) &&
                        <Box data-testId={"carousel-widget-modal-prev-arrow"}
                             onMouseEnter={()=>{
                                 setIsHoveringPrev(true)
                             }}
                             onMouseLeave={()=>setIsHoveringPrev(false)}
                             onTouchStart={()=>{
                                 setIsHoveringPrev(true)
                             }}

                             onTouchEnd={()=>{
                                 setTimeout(()=>{
                                     setIsHoveringPrev(false)
                                 }, 200)
                             }}
                             className={(isHoveringPrev ? classes.modalArrowHover+" " : "")+classes.modalViewAction}
                             onClick={()=>{swiperInstance?.slidePrev()}}>
                            <Box>
                                <ChevronLeftIcon sx={{fill: '#ffffff', color: '#ffffff'}} htmlColor={"#ffffff"} />
                            </Box>
                        </Box>}
                    {(modalArrowEnabledValue && itemsQty > 1) &&
                        <Box data-testId={"carousel-widget-modal-next-arrow"}
                             onMouseEnter={()=>{
                                 setIsHoveringNext(true)
                             }}
                             onMouseLeave={()=>setIsHoveringNext(false)}
                             onTouchStart={()=>{
                                 setIsHoveringNext(true)
                             }}
                             onTouchEnd={()=>{
                                 setTimeout(()=>{
                                     setIsHoveringNext(false)
                                 }, 200)
                             }}
                             className={(isHoveringNext ? classes.modalArrowHover+" " : "")+classes.modalViewAction + ' ' + classes.right}
                             onClick={()=>{swiperInstance?.slideNext()}}>

                            <Box >
                                <ChevronRightIcon sx={{fill: '#ffffff', color: '#ffffff'}} htmlColor={"#ffffff"} />
                            </Box>

                        </Box>}
                    {(isMobileView && openShare) && <ShareMobile isOpen={openShare} handleClose={handleClose} content={content}/>}
                    {(!isMobileView && openShare) && <ShareDesktop isOpen={openShare} handleClose={handleClose} content={content}/>}
                </Box>
            </Modal>



    </div>
}

ModalView.defaultProps = {
    getPrev: ()=>{},
    getNext: ()=>{},
    videos: [],
    activePosition : 0,
    autoplay: false,
    modal: {
        open: false,
        position: 0
    },
    closeModal: ()=>{}
}

export default ModalView;
